module.exports = __webpack_public_path__ + "img/button_gallery_off.2941ad41.png";